import { Link } from "react-router-dom";
import { useState } from "react";
import { useRecoilState } from "recoil";
import {
  admin,
  appointment,
  billing,
  customer,
  faq,
  finance,
  home,
  inventory,
  manual,
  request,
  service,
  specialEquipment,
  technician,
  training,
  user,
  audit,
} from "../lib/icons";
import { MdKeyboardArrowDown, MdRequestQuote } from "react-icons/md";
import uiConfigAtom from "../atoms/uiConfigAtom";

function Menu() {
  const [activeMenu, setActiveMenu] = useState("Dashboard");
  const [activeSubMenu, setActiveSubMenu] = useState("");
  const [uiConfig] = useRecoilState(uiConfigAtom);

  const access = window.localStorage.getItem("access");
  const menuStyle =
    "py-2 px-8 hover:text-customOne text-gray-500 text-md cursor-pointer flex gap-2 items-center ml-2 hover:bg-[#F3F4F6]";
  const optionStyle =
    "py-2 px-8 ml-4 text-gray-500 hover:text-customOne hover:font-semibold";
  const activeOptionStyle = "text-customOne font-semibold";

  function setMenu(e) {
    const value = e.target.innerHTML;
    console.log(value);
    setActiveMenu(value);
    // if(activeMenu === value) {
    //     setActiveMenu('')
    // } else {
    //     setActiveMenu(value)
    // }
  }

  const handleSubMenuClick = (subMenuName) => {
    setActiveSubMenu(subMenuName);
  };

  const handleMenuClick = (menuName) => {
    setActiveMenu(activeMenu === menuName ? null : menuName);
    // if(activeMenu === menuName) {
    //     setActiveMenu(null)
    // }else if (activeMenu === null) {
    //     setActiveMenu(menuName);
    // } else {
    //     setActiveMenu(null)
    // }
  };

  // useEffect(()=>{
  //     // setMenu();
  // },[activeMenu]);

  return (
    <div
      className='h-screen overflow-y-auto mt-4 pb-4 bg-white pt-16 border-r border-gray-200 sticky top-0'
      style={{ backgroundColor: uiConfig?.secondaryColor?.hex }}
    >
      <Link
        to={"/"}
        onClick={() => handleMenuClick("Dashboard")}
        className={
          menuStyle +
          " " +
          (activeMenu === "Dashboard" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
      >
        <img src={home} />
        <span>Dashboard</span>
      </Link>
      <Link
        to='/fc_quotes'
        onClick={() => handleMenuClick("FC_Quotes")}
        className={
          menuStyle +
          " bg-amber-100 " +
          (activeMenu === "FC_Quotes" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-amber-100")
        }
      >
        <MdRequestQuote className="text-xl" />
        <span>Fleet Service Request</span>
      </Link>
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Customer" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Customer")}
      >
        <img src={customer} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Customer</span>
          <MdKeyboardArrowDown className='text-2xl ml-auto' />
        </div>
      </div>
      {activeMenu === "Customer" ? (
        <div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/customer/individual" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/customer/individual'
              onClick={() => handleSubMenuClick("/customer/individual")}
            >
              Individual
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/customer/fleet" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/customer/fleet'
              onClick={() => handleSubMenuClick("/customer/fleet")}
            >
              Fleet
            </Link>
          </div>
        </div>
      ) : null}
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Finance" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Finance")}
      >
        <img src={finance} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Finance</span>
          <MdKeyboardArrowDown className='text-2xl' />
        </div>
      </div>
      {activeMenu === "Finance" ? (
        <div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_appointment"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_appointment'
              onClick={() => handleSubMenuClick("/finance/fleet_appointment")}
            >
              Fleet Appointments
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_open_estimates"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_open_estimates'
              onClick={() => handleSubMenuClick("/finance/fleet_open_estimates")}
            >
              Fleet Open Estimates
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_estimates"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_estimates'
              onClick={() => handleSubMenuClick("/finance/fleet_estimates")}
            >
              Fleet Estimates
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_invoice"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_invoice'
              onClick={() => handleSubMenuClick("/finance/fleet_invoice")}
            >
              Fleet Invoice
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_statements"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_statements'
              onClick={() => handleSubMenuClick("/finance/fleet_statements")}
            >
              Fleet Payments
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/appointment" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/finance/appointment'
              onClick={() => handleSubMenuClick("/finance/appointment")}
            >
              Appointments
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/resource_charges"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/resource_charges'
              onClick={() => handleSubMenuClick("/finance/resource_charges")}
            >
              Resource Charges
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/pending_invoices"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/pending_invoices'
              onClick={() => handleSubMenuClick("/finance/pending_invoices")}
            >
              Pending Invoices
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/operating_cost"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/operating_cost'
              onClick={() => handleSubMenuClick("/finance/operating_cost")}
            >
              Operating Cost
            </Link>
          </div>
          {/* <div className={optionStyle}>
                            <Link to='/finance/payment'>Payments</Link>
                        </div> */}
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/revenue" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/finance/revenue'
              onClick={() => handleSubMenuClick("/finance/revenue")}
            >
              Revenue
            </Link>
          </div>
        </div>
      ) : null}
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Admin" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Admin")}
      >
        <img src={admin} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Admin</span>
          <MdKeyboardArrowDown className='text-2xl ml-auto' />
        </div>
      </div>
      {activeMenu === "Admin" ? (
        <div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/admin/managers" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/admin/managers'
              onClick={() => handleSubMenuClick("/admin/managers")}
            >
              Managers
            </Link>
          </div>
          {/* <div className={optionStyle}>
                            <Link to='/admin/services'>Services</Link>
                        </div> */}
          <div
            className={`${optionStyle} ${activeSubMenu === "/admin/subscriptions" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/admin/subscriptions'
              onClick={() => handleSubMenuClick("/admin/subscriptions")}
            >
              Subscriptions
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/admin/equipments" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/admin/equipments'
              onClick={() => handleSubMenuClick("/admin/equipments")}
            >
              Special Equipment
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/admin/general_equipments"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/admin/general_equipments'
              onClick={() => handleSubMenuClick("/admin/general_equipments")}
            >
              General Equipment
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/admin/holidays" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/admin/holidays'
              onClick={() => handleSubMenuClick("/admin/holidays")}
            >
              Holidays
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/admin/customize" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/admin/customize'
              onClick={() => handleSubMenuClick("/admin/customize")}
            >
              Customize UI
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/admin/config" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/admin/config'
              onClick={() => handleSubMenuClick("/admin/config")}
            >
              Global Config
            </Link>
          </div>
        </div>
      ) : null}
      <Link
        to={"/employee"}
        className={
          menuStyle +
          " " +
          (activeMenu === "Employee" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Employee")}
      >
        <img src={user} />
        <span>Employee</span>
      </Link>
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Finance" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Finance")}
      >
        <img src={finance} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Finance</span>
          <MdKeyboardArrowDown className='text-2xl' />
        </div>
      </div>
      {activeMenu === "Finance" ? (
        <div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_appointment"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_appointment'
              onClick={() => handleSubMenuClick("/finance/fleet_appointment")}
            >
              Fleet Appointments
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_open_estimates"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_open_estimates'
              onClick={() => handleSubMenuClick("/finance/fleet_open_estimates")}
            >
              Fleet Open Estimates
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_estimates"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_estimates'
              onClick={() => handleSubMenuClick("/finance/fleet_estimates")}
            >
              Fleet Estimates
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_invoice"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_invoice'
              onClick={() => handleSubMenuClick("/finance/fleet_invoice")}
            >
              Fleet Invoice
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/fleet_statements"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/fleet_statements'
              onClick={() => handleSubMenuClick("/finance/fleet_statements")}
            >
              Fleet Payments
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/appointment" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/finance/appointment'
              onClick={() => handleSubMenuClick("/finance/appointment")}
            >
              Appointments
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/resource_charges"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/resource_charges'
              onClick={() => handleSubMenuClick("/finance/resource_charges")}
            >
              Resource Charges
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/pending_invoices"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/pending_invoices'
              onClick={() => handleSubMenuClick("/finance/pending_invoices")}
            >
              Pending Invoices
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/operating_cost"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/finance/operating_cost'
              onClick={() => handleSubMenuClick("/finance/operating_cost")}
            >
              Operating Cost
            </Link>
          </div>
          {/* <div className={optionStyle}>
                            <Link to='/finance/payment'>Payments</Link>
                        </div> */}
          <div
            className={`${optionStyle} ${activeSubMenu === "/finance/revenue" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/finance/revenue'
              onClick={() => handleSubMenuClick("/finance/revenue")}
            >
              Revenue
            </Link>
          </div>
        </div>
      ) : null}
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Directory Management" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Directory Management")}
      >
        <img src={inventory} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Directory Management</span>
          <MdKeyboardArrowDown className='text-3xl ml-auto' />
        </div>
      </div>
      {activeMenu === "Directory Management" ? (
        <div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/directory/dashboard" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/directory/dashboard'
              onClick={() => handleSubMenuClick("/directory/dashboard")}
            >
              Dashboard
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/directory/upload" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/directory/upload'
              onClick={() => handleSubMenuClick("/directory/upload")}
            >
              Upload
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/directory/files" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/directory/files'
              onClick={() => handleSubMenuClick("/directory/files")}
            >
              Files
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/directory/archive_files"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/directory/archive_files'
              onClick={() => handleSubMenuClick("/directory/archive_files")}
            >
              Archive Files
            </Link>
          </div>
          {/* <div className={`${optionStyle} ${activeSubMenu === '/directory/faqs' ? activeOptionStyle : ''}`}>
                            <Link to='/directory/faqs' onClick={() => handleSubMenuClick('/directory/faqs')}>FAQs</Link>
                        </div>
                        <div className={`${optionStyle} ${activeSubMenu === '/directory/fine_tune' ? activeOptionStyle : ''}`}>
                            <Link to='/directory/fine_tune' onClick={() => handleSubMenuClick('/directory/fine_tune')}>Fine-Tune</Link>
                        </div> */}
        </div>
      ) : null}
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Order Service" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Order Service")}
      >
        <img src={inventory} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Order Service</span>
          <MdKeyboardArrowDown className='text-3xl ml-auto' />
        </div>
      </div>
      {activeMenu === "Order Service" ? (
        <div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/order_service/catalog"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/order_service/catalog'
              onClick={() => handleSubMenuClick("/order_service/catalog")}
            >
              Catalog
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/order_service/quotes" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/order_service/quotes'
              onClick={() => handleSubMenuClick("/order_service/quotes")}
            >
              Quotations
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/order_service/orders" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/order_service/orders'
              onClick={() => handleSubMenuClick("/order_service/orders")}
            >
              Orders
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/order_service/inventory"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/order_service/inventory'
              onClick={() => handleSubMenuClick("/order_service/inventory")}
            >
              Inventory
            </Link>
          </div>
        </div>
      ) : null}
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Inventory" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Inventory")}
      >
        <img src={inventory} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Inventory</span>
          <MdKeyboardArrowDown className='text-2xl' />
        </div>
      </div>
      {activeMenu === "Inventory" ? (
        <div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/inventory/mobile_vans"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/inventory/mobile_vans'
              onClick={() => handleSubMenuClick("/inventory/mobile_vans")}
            >
              Mobile Vans
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/inventory/mobile_workshop"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/inventory/mobile_workshop'
              onClick={() => handleSubMenuClick("/inventory/mobile_workshop")}
            >
              Mobile Workshop
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/inventory/software_updates"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/inventory/software_updates'
              onClick={() => handleSubMenuClick("/inventory/software_updates")}
            >
              Software Updates
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/inventory/transfer_list"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/inventory/transfer_list'
              onClick={() => handleSubMenuClick("/inventory/transfer_list")}
            >
              Transfers
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/inventory/locations" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/inventory/locations'
              onClick={() => handleSubMenuClick("/inventory/locations")}
            >
              Locations
            </Link>
          </div>
        </div>
      ) : null}
      <Link
        to={"/fleet_media"}
        className={
          menuStyle +
          " " +
          (activeMenu === "fleet_media" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("fleet_media")}
      >
        <img src={manual} />
        <span>Fleet Media</span>
      </Link>
      <Link
        to='special_equipments'
        className={
          menuStyle +
          " " +
          (activeMenu === "Special Equipment" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Special Equipments")}
      >
        <img src={specialEquipment} />
        <span>Special Equipment</span>
      </Link>
      <Link
        to='general_equipments'
        className={
          menuStyle +
          " " +
          (activeMenu === "General Equipment" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("General Equipments")}
      >
        <img src={specialEquipment} />
        <span>General Equipment</span>
      </Link>
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Requests" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Requests")}
      >
        <img src={request} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Requests</span>
          <MdKeyboardArrowDown className='text-2xl ml-auto' />
        </div>
      </div>
      {activeMenu === "Requests" ? (
        <div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/requests/leave" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/requests/leave'
              onClick={() => handleSubMenuClick("/requests/leave")}
            >
              Leave
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/requests/certification"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/requests/certification'
              onClick={() => handleSubMenuClick("/requests/certification")}
            >
              Certification
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/requests/equipment_reservation"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/requests/equipment_reservation'
              onClick={() =>
                handleSubMenuClick("/requests/equipment_reservation")
              }
            >
              Equipment Reservation
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/requests/equipment_checkout"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/requests/equipment_checkout'
              onClick={() => handleSubMenuClick("/requests/equipment_checkout")}
            >
              Equipment Checkout
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/requests/inventory_transfer"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/requests/inventory_transfer'
              onClick={() => handleSubMenuClick("/requests/inventory_transfer")}
            >
              Inventory Transfer
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/requests/inventory_checkout"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/requests/inventory_checkout'
              onClick={() => handleSubMenuClick("/requests/inventory_checkout")}
            >
              Inventory Checkout
            </Link>
          </div>
          {/* <div className={optionStyle}>
                            <Link to='/requests/work_orders'>Work Orders</Link>
                        </div> */}
        </div>
      ) : null}
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Services" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Services")}
      >
        <img src={service} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Services</span>
          <MdKeyboardArrowDown className='text-2xl ml-auto' />
        </div>
      </div>
      {activeMenu === "Services" ? (
        <div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/services/service_bundle"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/services/service_bundle'
              onClick={() => handleSubMenuClick("/services/service_bundle")}
            >
              Service Bundle
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/services/service_list"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/services/service_list'
              onClick={() => handleSubMenuClick("/services/service_list")}
            >
              Service List
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/services/material_list"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/services/material_list'
              onClick={() => handleSubMenuClick("/services/material_list")}
            >
              Parts List
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/services/other" ? activeOptionStyle : ""
              }`}
          >
            <Link
              to='/services/other'
              onClick={() => handleSubMenuClick("/services/other")}
            >
              Others
            </Link>
          </div>
        </div>
      ) : null}
      <div
        className={
          menuStyle +
          " " +
          (activeMenu === "Appointments" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
        onClick={() => handleMenuClick("Appointments")}
      >
        <img src={appointment} />
        <div className='flex items-center w-full'>
          <span className='flex-grow'>Appointments</span>
          <MdKeyboardArrowDown className='text-2xl' />
        </div>
      </div>
      {activeMenu === "Appointments" ? (
        <div>
          {/* <div className={`${optionStyle} ${activeSubMenu === '/appointments/pending' ? activeOptionStyle : ''}`}>
                            <Link to='/appointments/pending' onClick={() => handleSubMenuClick('/appointments/pending')}>Pending</Link>
                        </div> */}
          <div
            className={`${optionStyle} ${activeSubMenu === "/appointments/upcoming"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/appointments/upcoming'
              onClick={() => handleSubMenuClick("/appointments/upcoming")}
            >
              Upcoming
            </Link>
          </div>
          <div
            className={`${optionStyle} ${activeSubMenu === "/appointments/cancelled"
              ? activeOptionStyle
              : ""
              }`}
          >
            <Link
              to='/appointments/cancelled'
              onClick={() => handleSubMenuClick("/appointments/cancelled")}
            >
              Cancelled
            </Link>
          </div>
        </div>
      ) : null}
      <Link
        to='/billing'
        onClick={() => handleMenuClick("Billing")}
        className={
          menuStyle +
          " " +
          (activeMenu === "Billing" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
      >
        <img src={billing} />
        <span>Billing</span>
      </Link>
      <Link
        to='/technician'
        onClick={() => handleMenuClick("Technicians")}
        className={
          menuStyle +
          " " +
          (activeMenu === "Technicians" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
      >
        <img src={technician} />
        <span>Technicians</span>
      </Link>
      <Link
        to='/trainings'
        onClick={() => handleMenuClick("Trainings")}
        className={
          menuStyle +
          " " +
          (activeMenu === "Trainings" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
      >
        <img src={training} />
        <span>Trainings</span>
      </Link>
      <Link
        to='/cars_manuals'
        onClick={() => handleMenuClick("Cars &amp; Manuals")}
        className={
          menuStyle +
          " " +
          (activeMenu === "Cars &amp; Manuals" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
      >
        <img src={manual} />
        <span>Cars & Manuals</span>
      </Link>
      <Link
        to='/faqs'
        onClick={() => handleMenuClick("FAQs")}
        className={
          menuStyle +
          " " +
          (activeMenu === "FAQs" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
      >
        <img src={faq} />
        <span>FAQs</span>
      </Link>
      <Link
        to='/audit_log'
        onClick={() => handleMenuClick("Audit Log")}
        className={
          menuStyle +
          " " +
          (activeMenu === "Audit Log" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
      >
        <img src={billing} />
        <span>Audit Log</span>
      </Link>
      <Link
        to='/work_order_audit_log'
        onClick={() => handleMenuClick("Work Order Audit Log")}
        className={
          menuStyle +
          " " +
          (activeMenu === "Work Order Audit Log" &&
            "text-customOne border-l-8 border-customOne rounded-l-md bg-[#F3F4F6]")
        }
      >
        <img src={billing} />
        <span>Estimate Audit Log</span>
      </Link>
    </div>
  );
}
export default Menu;
